import * as React from 'react';
import { FaClock } from 'react-icons/fa';

/**
 * Badge component indicating features that are not yet available.
 * Displays a small clock icon to indicate coming soon status.
 */
const ComingSoonBadge: React.FC = () => {
  return (
    <FaClock
      style={{
        fontSize: '10px',
        color: '#6c757d',
        marginLeft: '4px',
        opacity: 0.7,
      }}
      title="Coming Soon"
    />
  );
};

export default ComingSoonBadge;
